import { render } from "./SearchSelect.vue?vue&type=template&id=5926e10c&scoped=true"
import script from "./SearchSelect.vue?vue&type=script&lang=js"
export * from "./SearchSelect.vue?vue&type=script&lang=js"

import "./SearchSelect.vue?vue&type=style&index=0&id=5926e10c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5926e10c"]])

export default __exports__